// project imports

import UserList from '../pages/component-overview/UserList';
import ProtectedRoute from '../components/ProtectedRoute';

import DashboardLayout from 'layout/Dashboard';

// ==============================|| MAIN ROUTING ||============================== //
const withProtection = (element) => <ProtectedRoute>{element}</ProtectedRoute>;
const UsersRoutes = {
  path: '/users',
  element: withProtection(<DashboardLayout />), // 👈 Wrap with layout
  children: [
    {
      path: '',
      element: <UserList />
    },   
    // {
    //   path: '/:enc_id',
    //   element: <UserDetails />
    // }
  ]
};


export default UsersRoutes;
